import { useCustomer } from 'hooks/useCustomer';
import { NextPage } from 'next';
import React from 'react';
import Router from 'next/router';
import { getLoginRouteWithRedirect } from './route';

/**
At this stage we are doing the logic only in the client side. Therefore if there is any requirement to handle this
logic we can do by transfering that do Next SSR and hydrate the customer data on the react query client.
 * @param Page
 * @returns
 */
export const privatePage =
  (Page: NextPage, options?: { redirectUrl?: string }) => (pageProps: any) => {
    const { customer, loading, error } = useCustomer();

    if (loading) {
      return <div>Loading...</div>;
    }

    if (error) {
      return <div>Error...</div>;
    }

    if (customer?.id) {
      return <Page {...pageProps} />;
    }

    Router.push(getLoginRouteWithRedirect(options?.redirectUrl));

    return null;
  };
